var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 20L5.9594 19.2929L5.25229 20L5.9594 20.7071L6.6665 20ZM31.6665 21C32.2188 21 32.6665 20.5523 32.6665 20C32.6665 19.4477 32.2188 19 31.6665 19V21ZM15.9594 9.29289L5.9594 19.2929L7.37361 20.7071L17.3736 10.7071L15.9594 9.29289ZM5.9594 20.7071L15.9594 30.7071L17.3736 29.2929L7.37361 19.2929L5.9594 20.7071ZM6.6665 21H31.6665V19H6.6665V21Z",
    fill: "#7236CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.edebfd57d4997a114586de6abe7cb1dd.svg";
export { ForwardRef as ReactComponent };